import React, { useEffect } from 'react';
import { useState } from 'react';
import { useExtractTargets } from '@relyant/ui';
import { FileDrop, Loading, Text, TextForm, TextWithDropdown } from '@relyant/ui';
import { MenuProps } from 'antd';

export const ExtractTargets = () => {
  const { isLoading, data, call } = useExtractTargets();
  const [query] = useState<string>('');
  const [model, setModel] = useState<string>('gemini-1.5-flash');

  const dropdDownModels: MenuProps['items'] = [
    {
      key: '1',
      label: 'Gemini',
      onClick: () => {
        setModel('gemini-1.5-flash');
      },
    },
    {
      key: '2',
      label: 'GPT-4',
      onClick: () => {
        setModel('gpt-4o');
      },
    },
  ];

  const submitQuery = async (query) => {
    call({ html_table: query, model: model });
  };

  // const downloadCSV = (csvString, filename = 'targets.csv') => {
  //   const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  //   const url = URL.createObjectURL(blob);
  //   const link = document.createElement('a');
  //   link.href = url;
  //   link.setAttribute('download', filename);
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  useEffect(() => {
    if (data) {
      // console.log(data);
      //   downloadCSV(data);
    }
  }, [data]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div>
      <div>
        <TextWithDropdown title="Text to extract from" />
        <TextWithDropdown title={model} dropdDownItems={dropdDownModels} style={{ fontSize: 16, fontWeight: 500 }} />
        <div style={{ paddingTop: 16 }}>
          <Text
            value="Choose the LLM first. Then either upload the snapshots containg tables or 
          paste the html text of a table. \n The table will be exported into the Target spreadsheet into the founder@relyant.ai Google Drive"
          />
        </div>
      </div>

      <div className="flex-column" style={{ paddingTop: 32, gap: 20 }}>
        <FileDrop
          //   useButton={true}
          onDrop={({ pdfs, images }) => {
            call({ images: images, model: model });
            return;
          }}
          text="Upload images containing tables here"
          //   loadingText="Loading..."
          accept="image/png, image/jpeg, image/jpg"
          multiple={true}
          setFiles={(docs) => {}}
          loadingOnlyText={true}
          extractElements={false}
        />

        <TextForm
          disabled={false}
          initialText={query !== 'undefined' ? query : ''}
          placeholder="Enter your text here. Press Enter to start the review."
          handleSubmit={submitQuery}
          minRows={15}
          maxRows={200}
          characterLimit={500 * 1000}
          clearOnSubmit={false}
        ></TextForm>
      </div>
    </div>
  );
};
